<script setup lang="ts">
import PageTitle from '@/components/PageTitle.vue'
</script>

<template>
  <PageTitle :title="$t('saml-redirect.card.title')" />
</template>
